<!-- src/components/CategoryPage.vue -->
<template>
  <!-- 这里把根节点做成真正的滚动容器 -->
  <div class="category-page" ref="scrollContainer" @scroll="onScroll">
    <!-- 筛选条件 -->
    <div class="filter-group" v-for="(opts, gidx) in filters" :key="gidx">
      <div class="filter-list">
        <div
          v-for="(opt, idx) in opts"
          :key="idx"
          :class="['filter-item', selected[gidx] === idx ? 'active' : '']"
          @click="onSelect(gidx, idx, $event)"
        >
          {{ opt }}
        </div>
      </div>
    </div>

    <!-- 视频列表 -->
    <div class="video-list">
      <div
        class="video-card"
        v-for="item in videos"
        :key="item.id"
        @click="playVideo(item.id)"
      >
        <img :src="item.img" alt="封面" />
        <div class="name">{{ item.name }}</div>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>

    <!-- 加载状态提示 -->
    <div class="loading" v-if="loading">加载中...</div>
    <div class="end" v-else-if="page >= pagecount">已加载全部</div>
  </div>
</template>

<script>
export default {
  name: 'CategoryPage',
  props: { category: { type: String, required: true } },
  data() {
    return {
      filters: [
        ['全部', '古装', '战争', '青春偶像', '喜剧', '家庭'],
        ['全部', '大陆', '韩国', '香港', '台湾', '日本'],
        ['全部', '2025', '2024', '2023', '2022', '2021']
      ],
      selected: [0, 0, 0],
      videos: [],
      page: 0,
      pagecount: 1,
      pageSize: 20,
      loading: false
    };
  },
  computed: {
    typeId() {
      const map = { 电影:1, 电视剧:2, 综艺:3, 动漫:4, 短剧:38 };
      return map[this.category] || 1;
    }
  },
  watch: {
    selected: { handler() { this.resetAndLoad() }, deep: true },
    category() { this.resetAndLoad() }
  },
  mounted() {
    this.resetAndLoad();
  },
  methods: {
    onSelect(gidx, idx, e) {
      this.selected.splice(gidx, 1, idx);
      this.$nextTick(() =>
        e.target.scrollIntoView({ behavior: 'smooth', inline: 'center' })
      );
    },
    stripHtml(html) {
      return html.replace(/<[^>]+>/g,'').trim();
    },
    async loadPage(pg, append = false) {
      if (this.loading || pg < 1 || (this.pagecount && pg > this.pagecount)) return;
      this.loading = true;
      this.page = pg;
      try {
        const params = new URLSearchParams({
          t: this.typeId,
          pageSize: this.pageSize,
          pg,
          genre: this.filters[0][this.selected[0]],
          region: this.filters[1][this.selected[1]],
          year: this.filters[2][this.selected[2]]
        });
        // const json = await this.$fetchData(`http://110.40.74.118:3345/api.php/api/video/index?${params}`);
        
        const res = await fetch(`http://110.40.74.118:3345/api.php/video/index?${params}`);
        const json = await res.json();

        if (json.code === 1 && Array.isArray(json.list)) {
          const newItems = json.list.map(item => ({
            id: item.vod_id,
            img: item.vod_pic,
            name: item.vod_name,
            desc: item.vod_content
              ? this.stripHtml(item.vod_content)
              : item.vod_remarks || ''
          }));
          if (append) this.videos.push(...newItems);
          else this.videos = newItems;
          this.pagecount = json.pagecount;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    // 重置并加载第 1 页
    resetAndLoad() {
      this.videos = [];
      this.page = 0;
      this.pagecount = 1;
      this.loadPage(1, false);
    },
    // 容器滚动时触发
    onScroll() {
      const c = this.$refs.scrollContainer;
      if (this.loading || this.page >= this.pagecount) return;
      // 滚到底部 100px 以内时加载下一页
      if (c.scrollHeight - (c.scrollTop + c.clientHeight) < 300) {
        this.loadPage(this.page + 1, true);
      }
    },
    playVideo(id) {
      const msg = { action:'playVideo', videoId:id };
      if (window.webkit?.messageHandlers?.nativeHandler) {
        window.webkit.messageHandlers.nativeHandler.postMessage(msg);
      } else if (window.Native?.postMessage) {
        window.Native.postMessage(JSON.stringify(msg));
      } else {
        console.log('播放模拟：', msg);
      }
    }
  }
};
</script>

<style scoped>
.category-page {
  /* 让这个容器撑满整个面板并可滚动 */
  height: 100%;
  overflow-y: auto;
  padding: 12px;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
}

/* 筛选同之前 */
.filter-group { margin-bottom: 12px; }
.filter-list {
  display: flex; overflow-x: auto;
  -ms-overflow-style: none; scrollbar-width: none;
}
.filter-list::-webkit-scrollbar { display: none }
.filter-item {
  flex-shrink: 0; padding: 6px 12px; margin-right: 8px;
  background: #f0f0f0; border-radius: 16px; cursor: pointer;
  white-space: nowrap;
}
.filter-item.active { background: #1890ff; color: #fff }

/* 视频网格 */
.video-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px,1fr));
  gap: 10px; margin-top: 16px;
}
.video-card { cursor: pointer }
.video-card img {
  width:100%; aspect-ratio:3/4; object-fit:cover; border-radius:4px;
}
.name {
  margin-top:4px; font-size:0.9rem;
  white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
}
.desc {
  font-size:0.75rem; color:#888; height:1.2rem; overflow:hidden;
}

/* 加载提示 */
.loading, .end {
  text-align:center; margin:16px 0; color:#666;
}
</style>